import React from 'react';

const QuickCalculator: React.FC = () => {
  return (
    <div className="p-4">
      <h3 className="text-xl font-bold mb-4 text-[#40e0d0]">Quick Calculator</h3>
      <p className="text-muted-foreground mb-2">(Estimate your carbon impact for trips or events here.)</p>
      {/* TODO: Add calculator fields and logic */}
    </div>
  );
};

export default QuickCalculator;


